"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _cheerio = _interopRequireDefault(require("cheerio"));
var _ResourceLoader = _interopRequireDefault(require("./ResourceLoader.proptypes"));
var _constant = require("./constant");
var ResourceLoader = function ResourceLoader(_ref) {
  var resourceUrl = _ref.resourceUrl,
    delay = _ref.delay,
    resourceContent = _ref.resourceContent;
  var assetsTypes = [_constant.TYPES.img, _constant.ASSET_TYPE.script, _constant.TYPES.stylesheet];
  var urls = [];
  var getAssetType = function getAssetType(url) {
    if (url.includes(_constant.TYPES.js)) {
      return _constant.ASSET_TYPE.script;
    }
    if (url.includes(_constant.TYPES.css)) {
      return _constant.ASSET_TYPE.style;
    }
    if (new RegExp(_constant.IMG_REGEX).test(url)) {
      return _constant.ASSET_TYPE.image;
    }
    return _constant.ASSET_TYPE.font;
  };
  var injectResource = function injectResource(url) {
    if (typeof document !== 'undefined') {
      var link = document.createElement(_constant.TYPES.link);
      link.rel = _constant.TYPES.prefetch;
      link.as = getAssetType(url);
      link.href = url;
      document.head.appendChild(link);
    }
  };
  var parseContent = function parseContent(content) {
    var cheerIO = _cheerio.default.load(content.toString(), {
      xmlMode: false
    });
    var getAsset = function getAsset(assetType, assetAttr) {
      cheerIO(assetType).each(function (idx, script) {
        var src = cheerIO(script).attr(assetAttr);
        if (src && !urls.includes(src)) {
          if (src.includes(_constant.TYPES.http)) {
            urls.push(src);
          } else {
            urls.push(src.startsWith('/') ? "".concat(resourceUrl).concat(src) : "".concat(resourceUrl, "/").concat(src));
          }
        }
      });
    };
    assetsTypes.forEach(function (assetType) {
      var assetAttr = _constant.TYPES.src;
      if (assetType === _constant.TYPES.stylesheet) {
        assetAttr = _constant.TYPES.href;
      }
      getAsset(assetType, assetAttr);
    });
    if (urls.length) {
      urls.forEach(injectResource);
    }
  };
  setTimeout(function () {
    if (!resourceContent) {
      (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var res;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetch(resourceUrl).then(function (resp) {
                return resp.text();
              });
            case 2:
              res = _context.sent;
              parseContent(res);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    } else {
      parseContent(resourceContent);
    }
  }, delay);
  return null;
};
ResourceLoader.propTypes = _ResourceLoader.default.PropTypes;
ResourceLoader.defaultProps = _ResourceLoader.default.DefaultProps;
var _default = ResourceLoader;
exports.default = _default;